import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CommonContextProvider } from './contexts/common';
import { AuthContextProvider } from './contexts/Auth';
import { AlertProvider } from './contexts/Alert';
import { DemographicsContextProvider } from './contexts/Demographics';
import { LanguagesContextProvider } from './contexts/Languages';
import { OnboardingContextProvider } from './contexts/onboarding';
import { TreatmentContextProvider } from './contexts/teamentModalities';
import { SpecialtiesContextProvider } from './contexts/specialties';
import { BasicInfoContextProvider } from './contexts/BasicInfo';
import { DegreesContextProvider } from './contexts/Degrees';
import { FeesContextProvider } from './contexts/Fees';
import { InterestsContextProvider } from './contexts/Interests';
import { NetworkContextProvider } from './contexts/NetWork';
import { ReferralsContextProvider } from './contexts/Referral';
import { UserProfileContextProvider } from './contexts/UserProfile';
import CustomThemeProvider from './theme';
import { HomePageContextProvider } from './contexts/HomePage';
import { ClientServedContextProvider } from './contexts/ClientServed';
import { CredentialsContextProvider } from './contexts/Credentials';
import { SettingsContextProvider } from './contexts/Settings';
import { TrainingContextProvider } from './contexts/Training';
import { GeneralProfileContextProvider } from './contexts/Organization';
import { TeamsContextProvider } from './contexts/Teams';
import { NotificationsProvider } from './contexts/Notifications';
import {
  UIKitSettingsBuilder,
  CometChatUIKit,
} from "@cometchat/chat-uikit-react";
import { setupLocalization } from "./CometChat/utils/utils";
import { CometChatProvider } from "./CometChat/context/CometChatContext";
import MaintenanceMode from './pages/MaintenanceMode';

export const COMETCHAT_CONSTANTS = {
  APP_ID: process.env.REACT_APP_COMETCHAT_APP_ID,
  REGION: process.env.REACT_APP_COMETCHAT_REGION?.toUpperCase(),
  AUTH_KEY: process.env.REACT_APP_COMETCHAT_AUTH_KEY,
};

const isMaintenanceMode = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
const root = ReactDOM.createRoot(document.getElementById('root'));

if (isMaintenanceMode) {
  root.render(<MaintenanceMode />);
} else {
  const uiKitSettings = new UIKitSettingsBuilder()
    .setAppId(COMETCHAT_CONSTANTS.APP_ID)
    .setRegion(COMETCHAT_CONSTANTS.REGION)
    .setAuthKey(COMETCHAT_CONSTANTS.AUTH_KEY)
    .subscribePresenceForAllUsers()
    .build();

  CometChatUIKit.init(uiKitSettings)?.then(() => {
    setupLocalization();
    root.render(
      <CustomThemeProvider>
        <AlertProvider>
          <CommonContextProvider>
            <AuthContextProvider>
              <OnboardingContextProvider>
                <BasicInfoContextProvider>
                  <GeneralProfileContextProvider>
                    <TreatmentContextProvider>
                      <ClientServedContextProvider>
                        <SpecialtiesContextProvider>
                          <DemographicsContextProvider>
                            <LanguagesContextProvider>
                              <DegreesContextProvider>
                                <FeesContextProvider>
                                  <InterestsContextProvider>
                                    <NetworkContextProvider>
                                      <ReferralsContextProvider>
                                        <UserProfileContextProvider>
                                          <HomePageContextProvider>
                                            <CredentialsContextProvider>
                                              <TrainingContextProvider>
                                                <SettingsContextProvider>
                                                  <TeamsContextProvider>
                                                    <NotificationsProvider>
                                                      <CometChatProvider>
                                                        <App />
                                                      </CometChatProvider>
                                                    </NotificationsProvider>
                                                  </TeamsContextProvider>
                                                </SettingsContextProvider>
                                              </TrainingContextProvider>
                                            </CredentialsContextProvider>
                                          </HomePageContextProvider>
                                        </UserProfileContextProvider>
                                      </ReferralsContextProvider>
                                    </NetworkContextProvider>
                                  </InterestsContextProvider>
                                </FeesContextProvider>
                              </DegreesContextProvider>
                            </LanguagesContextProvider>
                          </DemographicsContextProvider>
                        </SpecialtiesContextProvider>
                      </ClientServedContextProvider>
                    </TreatmentContextProvider>
                  </GeneralProfileContextProvider>
                </BasicInfoContextProvider>
              </OnboardingContextProvider>
            </AuthContextProvider>
          </CommonContextProvider>
        </AlertProvider>
      </CustomThemeProvider>
    );
  });

  reportWebVitals();
}